import * as React from 'react'
import * as Styled from './Typography.styles'

const Typography = ({
  children = null,
  customWeight = null,
  rendersAs = null,
  strikethrough = false,
  variant = 'body',
  ...props
}) => {
  let Component = Styled.Typography

  if (rendersAs) {
    Component = Styled.Typography.withComponent(rendersAs)
  } else if (/h\d/.test(variant)) {
    Component = Styled.Typography.withComponent(variant)
  }

  return (
    <Component
      className={`leshen-typography-${variant}`}
      variant={variant}
      {...props}
      strikethrough={strikethrough}
      customWeight={customWeight}
    >
      {children}
    </Component>
  )
}

export default Typography
